<template>
  <path
    d="M3.41 15H16a2 2 0 0 0 2-2 1 1 0 0 1 2 0 4 4 0 0 1-4 4H3.41l2.3 2.3a1 1 0 0 1-1.42 1.4l-4-4a1 1 0 0 1 0-1.4l4-4a1 1 0 1 1 1.42 1.4L3.4 15h.01zM4 7a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 0 1 4-4h12.59l-2.3-2.3a1 1 0 1 1 1.42-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.42-1.4L16.6 7H4z"
  />
</template>
